<!--<p>url = {{url3_5}}</p><p>legacyWebUi - {{legacyWebUI}}</p><p>listSpec = {{listSpec}}</p>-->
<ng-template [ngIf]="legacyWebUI && url3_5">
  <p *ngIf="unsupportedPattern && !isProduction"
     style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
    CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
  </p>
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
  ></lm-html-url-doc>
</ng-template>

<ng-container *ngIf="!url3_5">
  <div class="scrollable-flex single pane">
    <!-- Insert toolbar for compare button here! -->
    <lm-toolbar
      [maxVisibleButtons]="2"
      [hideToolbarTitles]="true"
      [buttons]="toolbarButtons"
      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
    ></lm-toolbar>
    <div soho-busyindicator
         class="main-audit-div"
         [blockUI]="true"
         [displayDelay]="20"
         [transparentOverlay]="true"
    >
      <div soho-datagrid
           [hidden]="!auditData"
           (selected)="onRowSelected($event)"
           [emptyMessage]="null"
      ></div>
    </div>
  </div>
</ng-container>
